import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c9a5410"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field-diff-modal" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "text-lg font-bold mb-4" }
const _hoisted_4 = { class: "diff-content" }
const _hoisted_5 = {
  key: 0,
  class: "html-diff"
}
const _hoisted_6 = { class: "diff-section" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-sm font-semibold text-gray-600 mb-2" }, "Gammel verdi:", -1))
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "diff-section" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-sm font-semibold text-gray-600 mb-2" }, "Ny verdi:", -1))
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 1,
  class: "text-diff"
}
const _hoisted_13 = { class: "diff-section" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-sm font-semibold text-gray-600 mb-2" }, "Gammel verdi:", -1))
const _hoisted_15 = { class: "old-content" }
const _hoisted_16 = { class: "diff-section" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-sm font-semibold text-gray-600 mb-2" }, "Ny verdi:", -1))
const _hoisted_18 = { class: "new-content" }

import Modal from "@/Components/General/Modal.vue";
import Button from "@/Components/Buttons/Button.vue";
import { computed } from "vue";
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldDiffModal',
  props: {
    fieldLabel: {},
    fieldName: {},
    oldValue: {},
    newValue: {}
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props;





const close = () => {
  emit("close");
};

const htmlFields = ['description', 'measures', 'measures_taken'];

// Fields that contain dates
const dateFields = ['occured_at', 'deadline', 'closed_at'];

const isHtmlField = computed(() => {
  return htmlFields.includes(props.fieldName);
});

const isDateField = computed(() => {
  return dateFields.includes(props.fieldName);
});

const formatValue = (value: string): string => {
  if (!value || value === '(tom)') {
    return '(tom)';
  }
  
  // Handle date fields
  if (isDateField.value) {
    try {
      const date = dayjs(value);
      if (date.isValid()) {
        return date.format('DD.MM.YYYY');
      }
    } catch (e) {
      // If date parsing fails, return the original value
    }
  }
  
  return value;
};

const highlightHtmlDiff = (content: string, type: 'added' | 'removed') => {
  if (!content) return '';
  
  // For HTML content, we'll do a simple text-based diff
  const highlightClass = type === 'added' ? 'diff-added' : 'diff-removed';
  
  // Clean up the HTML content for better display
  let cleanedContent = content
    .replace(/<p><\/p>/g, '<p>&nbsp;</p>') // Replace empty paragraphs with space
    .replace(/<p>/g, '<p class="diff-paragraph">') // Add class to paragraphs
    .replace(/<br\s*\/?>/g, '<br class="diff-line-break">'); // Add class to line breaks
  
  return `<div class="${highlightClass}">${cleanedContent}</div>`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, { onDismiss: close }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.fieldLabel), 1),
          _createVNode(Button, {
            color: "gray",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createTextVNode("Lukk")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          (isHtmlField.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", {
                    class: "old-content",
                    innerHTML: highlightHtmlDiff(_ctx.oldValue, 'removed')
                  }, null, 8, _hoisted_8)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", {
                    class: "new-content",
                    innerHTML: highlightHtmlDiff(_ctx.newValue, 'added')
                  }, null, 8, _hoisted_11)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(formatValue(_ctx.oldValue)), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, _toDisplayString(formatValue(_ctx.newValue)), 1)
                ])
              ]))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})